import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const storageUser = sessionStorage.getItem('accessToken');
        const token_type = 'Bearer';
        const xCompuse = sessionStorage.getItem('xCompuse');

        if (storageUser && !req.url.includes(environment.clientRoot)) {
            req = req.clone({
                headers: req.headers.set('Authorization', `${token_type} ${storageUser}`)
            });

            req = req.clone({
                headers: req.headers.set('X-Compuse', `${xCompuse}`)
            });
        }

        return new Observable(observer => {
            const subscription = next.handle(req)
                .subscribe(
                    event => {
                        if (event instanceof HttpResponse) {
                            observer.next(event);
                        }
                    },
                    err => {
                        // // alert('error returned');
                        observer.error(err);
                    },
                    () => {
                        observer.complete();
                    });
            // Remove request from queue when cancelled
            return () => {
                subscription.unsubscribe();
            };
        });
    }
}
